import React from 'react';
import { Loader2Icon, CheckCircleIcon, AlertCircleIcon } from 'lucide-react';
export const SaveStatusIndicator = ({ status }) => {
    const icon = {
        idle: React.createElement(CheckCircleIcon, { className: "w-4 h-4 text-green-500" }),
        saving: React.createElement(Loader2Icon, { className: "w-4 h-4 animate-spin" }),
        saved: React.createElement(CheckCircleIcon, { className: "w-4 h-4 text-green-500" }),
        error: React.createElement(AlertCircleIcon, { className: "w-4 h-4" }),
    }[status];
    const label = {
        idle: 'Saved',
        saving: 'Saving...',
        saved: 'Saved',
        error: 'Save failed',
    }[status];
    const color = status === 'error' ? 'text-red-500' : 'text-gray-500';
    return (React.createElement("div", { className: `flex items-center gap-1.5 px-3 py-1.5 text-sm w-28 ${color}` },
        icon,
        React.createElement("span", null, label)));
};
